import React from 'react';
import { Box } from '@mui/joy';
import { SubcontractorList } from '../../components/subcontractors';

export const SubcontractorsListPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <SubcontractorList />
    </Box>
  );
};